import { Component } from "vue-property-decorator";
import Template from "./template.vue";
import FormsMixin from "@/mixins/FormsMixin";

@Component({
  mixins: [Template],
})
export default class NotFound extends FormsMixin {}
